import { fromJS } from 'immutable';

import { LOGOUT } from 'redux/reducers/user';
import { RENAME_ID } from 'redux/reducers/orders';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

const SET_UI_STATE = 'kroost/app/SET_UI_STATE';
const DROPZONE_ACTIVATE = 'kroost/app/DROPZONE_ACTIVATE';
const DROPZONE_DEACTIVATE = 'kroost/app/DROPZONE_DEACTIVATE';
const PICKER_ACTIVE = 'kroost/app/PICKER_ACTIVE';
const PICKER_DEACTIVE = 'kroost/app/PICKER_DEACTIVE';
const UPDATE_DIMENSIONS = 'kroost/app/UPDATE_DIMENSIONS';
const SET_SIDEBAR = 'kroost/app/SET_SIDEBAR';
const SET_DRAGGING = 'kroost/app/SET_DRAGGING';
const SET_DRAGGING_PREVIEW = 'kroost/app/SET_DRAGGING_PREVIEW';
const SET_NOTIFICATION = 'kroost/app/SET_NOTIFICATION';
const SET_ORDER_VALIDATION = 'kroost/app/SET_ORDER_VALIDATION';
const SET_PREVIEW = 'kroost/app/SET_PREVIEW';

export const INITIALIZE = 'kroost/app/INITIALIZE';
export const CANCEL_INITIALIZE = 'kroost/app/CANCEL_INITIALIZE'
export const SET_ACTIVE_ORDER = 'kroost/app/SET_ACTIVE_ORDER';
export const SET_ACTIVE_SPREAD = 'kroost/app/SET_ACTIVE_SPREAD';

// Initial routing state
const initialState = fromJS({
  dimensions: {
    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
  },
  picker: {
    active: false,
  },
  dropzone: {
    active: false,
  },
  initializing: true,
  giftcard: null,
  isDragging: false,
  draggingPreview: false,
  activeBookId: null,
  activeOrderId: null,
  activeSpreadIds: {},
  sidebar: 'photos',
  sidebarParams: {},
  notifications: {},
  orderValidation: {},
  ui: {
    initializing: true,
    validating: false,
  },
  previews: {},
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGOUT:
      return state.set('activeOrderId', null);
    case DROPZONE_ACTIVATE:
      return state.setIn(['dropzone', 'active'], true);
    case DROPZONE_DEACTIVATE:
      return state.setIn(['dropzone', 'active'], false);
    case SET_DRAGGING:
      return state
        .set('isDragging', action.dragging)
        .set('draggingPreview', action.dragging === false ? false : state.get('draggingPreview'));
    case SET_DRAGGING_PREVIEW:
      return state.set('draggingPreview', action.moment);
    case UPDATE_DIMENSIONS:
      return state.mergeIn(['dimensions'], {
        width: action.width,
        height: action.height,
      });
    case PICKER_ACTIVE:
      return state.setIn(['picker', 'active'], true);
    case PICKER_DEACTIVE:
      return state.setIn(['picker', 'active'], false);
    case SET_SIDEBAR:
      return state.set('sidebar', action.item).set('sidebarParams', action.params);
    case SET_ACTIVE_ORDER:
      return state.set('activeOrderId', action.id);
    case SET_ACTIVE_SPREAD:
      return state.setIn(['activeSpreadIds', state.get('activeOrderId')], action.spread);
    case RENAME_ID: {
      const order = state.getIn(['activeSpreadIds', action.oldId]);

      // Rename active order
      const newState = state.set(
        'activeOrderId',
        state.get('activeOrderId') === action.oldId ? action.newId : state.get('activeOrderId')
      );

      if (!order) {
        return newState;
      }

      return newState.deleteIn(['activeSpreadIds', action.oldId]).setIn(['activeSpreadIds', action.newId], order);
    }
    case SET_NOTIFICATION:
      if (action.notification) {
        return state.setIn(['notifications', action.key], action.notification);
      } else {
        return state.deleteIn(['notifications', action.key]);
      }
    case SET_ORDER_VALIDATION:
      return state.setIn(
        ['orderValidation', state.get('activeOrderId'), action.validationType],
        fromJS(action.validation)
      );
    case SET_UI_STATE:
      return state.setIn(['ui', action.name], action.value);
    case SET_PREVIEW:
      return state.setIn(['previews', action.orderId, action.momentId], fromJS(action.preview));
    default:
      return state;
  }
}

export function cancelInitialize () {
  return {
    type: CANCEL_INITIALIZE
  }
}

export function initialize(bookId = null, orderId = null, createOrder = false) {
  return {
    type: INITIALIZE,
    bookId,
    orderId,
    createOrder,
  };
}

export function setInitializing(initializing) {
  return {
    type: SET_UI_STATE,
    name: 'initializing',
    value: initializing,
  };
}

export function setUIState(name, value) {
  return {
    type: SET_UI_STATE,
    name,
    value,
  };
}

export function activateDropzone() {
  return {
    type: DROPZONE_ACTIVATE,
  };
}

export function deactivateDropzone() {
  return {
    type: DROPZONE_DEACTIVATE,
  };
}

export function setDragging(dragging) {
  return {
    type: SET_DRAGGING,
    dragging,
  };
}

export function setDraggingPreview(moment) {
  return {
    type: SET_DRAGGING_PREVIEW,
    moment,
  };
}

export function updateDimensions(width, height) {
  return {
    type: UPDATE_DIMENSIONS,
    width,
    height,
  };
}

export function openPicker() {
  return {
    type: PICKER_ACTIVE,
  };
}

export function closePicker() {
  return {
    type: PICKER_DEACTIVE,
  };
}

export function setSidebar(item, params = {}) {
  return {
    type: SET_SIDEBAR,
    item,
    params,
  };
}

export function setActiveOrder(id) {
  return {
    type: SET_ACTIVE_ORDER,
    id,
  };
}

export function setActiveSpread(spread) {
  return {
    type: SET_ACTIVE_SPREAD,
    spread,
  };
}

export function setNotification(key, notification) {
  return {
    type: SET_NOTIFICATION,
    key,
    notification,
  };
}

export function setOrderValidation(validationType, validation) {
  return {
    type: SET_ORDER_VALIDATION,
    validationType,
    validation,
  };
}

export function setPreview(orderId, momentId, preview) {
  return {
    type: SET_PREVIEW,
    orderId,
    momentId,
    preview,
  };
}



// WEBPACK FOOTER //
// ./app/redux/reducers/app.js